module.exports = __webpack_public_path__ + "img/3.ad4871a2.jpeg";